__turbopack_context__.v({
  "active": "index-module__fTTu7W__active",
  "link": "index-module__fTTu7W__link",
});
